import { useEffect, useState } from 'react'
import { Box, Card, CardBody, CardHeader, Heading, Spinner, Text, VStack } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { IssueCategoryForm } from '@/components/forms/IssueCategoryForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function IssueCategoryEditPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { id } = useParams<{ id: string }>()
  const numericId = id ? Number(id) : undefined
  const [isValidating, setIsValidating] = useState(true)

  useEffect(() => {
    if (!numericId || Number.isNaN(numericId)) {
      navigate('/service-catalog/issue-categories', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [numericId, navigate])

  const handleDone = () => navigate('/service-catalog/issue-categories')

  if (isValidating || !numericId) {
    return (
      <Box p={4}>
        <Card>
          <CardBody display="flex" alignItems="center" justifyContent="center" minH="200px">
            <VStack spacing={4}>
              <Spinner size="xl" color="blue.500" />
              <Text>Loading...</Text>
            </VStack>
          </CardBody>
        </Card>
      </Box>
    )
  }

  return (
    <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
      <Box minW={0} display="flex" flexDirection="column" overflow="hidden" flex="1">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0}>
            <Heading size="md">Edit Issue Category</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Update this issue category
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0}>
            <IssueCategoryForm issueCategoryId={numericId} onSuccess={handleDone} onCancel={handleDone} />
          </CardBody>
        </Card>
      </Box>
    </Box>
  )
}
